import React from 'react';
import "./Footer.css";
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <div className="footer">
            <div>
                <div className="footer__row">
                    <ul className="unstyled-list">
                        <h3>Get to Know Us</h3>
                            <li>About us</li>
                            <li>Careers</li>
                            <li>Press Releases</li>
                            <li>Amazon Cares</li>
                            <li>Gift a Smile</li>
                    </ul>

                    <ul className="unstyled-list">
                        <h3>Connect with Us</h3>
                            <li>Facebook</li>
                            <li>Twitter</li>
                            <li>Instagram</li>
                            <li>Linkedin</li>
                    </ul>

                    <ul className="unstyled-list">
                        <h3>Make Money with Us</h3>
                            <li>Sell on Amazon</li>
                            <li>Sell under Amazon Accelerator</li>
                            <li>Become an Affiliate</li>
                            <li>Fulfilment by Amazon</li>
                            <li>Advertise Your Products</li>
                            <li>Amazon Pay on Merchants</li>
                    </ul>

                    <ul className="unstyled-list">
                        <h3>Let Us Help You</h3>
                            <li>COVID-19 and Amazon</li>
                            <li>Your Account</li>
                            <li>Returns Centre</li>
                            <li>100% Purchase Protection</li>
                            <li>Amazon App Download</li>
                            <li>Amazon Assistant Download</li>
                            <li>Help</li>
                    </ul>
                </div>
            </div>           
            <Link to="/">
                <img className="footer__logo" src="https://pngimg.com/uploads/amazon/amazon_PNG25.png" alt="" />
            </Link>        
        </div>
    );
}

export default Footer

